import React from "react"
import Drawer from "@mui/material/Drawer"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import { COLORS } from "../../../utils"

export default function PropertiesPanel({open, onClose, recipeUniqueCode, pseName, children}) {
    return (
        <div>
            <Drawer open={open} onClose={onClose} anchor="left">
                <div style={style.panel}>
                    {/* Header */}
                    {recipeUniqueCode && (
                        <div style={style.header}>
                            {recipeUniqueCode} - {pseName}
                        </div>
                    )}
                    <IconButton onClick={onClose} style={style.closeButton}>
                        <CloseIcon style={style.closeIcon} />
                    </IconButton>
                    
                    {/* Content */}
                    <div style={style.content}>
                        {children}
                    </div>
                </div>
            </Drawer>
        </div>
    )
}

const style = {
    panel: {
        width: 674,
        height: "100%",
        display: "flex",
        flexDirection: "column"
    },
    header: {
        display: "flex",
        position: "relative",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "32px 24px",
        fontSize: "20px",
        fontWeight: 500,
        color: COLORS.BLACK800,
        lineHeight: "140%"
    },
    closeButton: {
        position: "absolute",
        right: 16,
        top: 16,
        width: 32,
        height: 32,
        padding: 0
    },
    closeIcon: {
        width: 32,
        height: 32,
        padding: 0
    },
    content: {
        flex: 1,
        overflowY: "auto",
        padding: "0 24px"
    }
}